const notificationTemplateAction = {
  NOTIFICATION_EDIT_SET_TEMPLATE: 'NOTIFICATION_EDIT_SET_TEMPLATE',
};

export default notificationTemplateAction;
